// extracted by mini-css-extract-plugin
module.exports = {"CardBox":"ColorCards_CardBox__24aez"};